export const smoothscroll = (el = window, raf = true) => {
	window.ticking = false
	let delta = 0
	let scrollTop = 0
	let dir = 1
	let bounds = {}

	if (window == el) {
		scrollTop = window.scrollY
		bounds = {
			height: Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0),
			width: Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0)
		}
	} else {
		scrollTop = el.scrollTop
		bounds = el.getBoundingClientRect()
	}

	window.addEventListener('resize', () => {
		if (window == el) {
			scrollTop = window.scrollY
			bounds = {
				height: Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0),
				width: Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0)
			}
		} else {
			scrollTop = el.scrollTop
			bounds = el.getBoundingClientRect()
		}
	})

	const root = document.querySelector(':root')

	const emitEvent = (evt) => {
		scrollTop = window == el ? window.scrollY : el.scrollTop
		window.ticking = false
		delta = scrollTop - delta
		dir = delta < 0 ? -1 : 1

		console.log('emitEvent', evt)
		const customEvent = new CustomEvent('smoothScroll', {
			detail: {
				bounds,
				scrollTop,
				delta,
				dir,
			}
		})
		delta = scrollTop

		if (raf) {
			if (!window.ticking) {
				requestAnimationFrame(() => {
					root.style.setProperty('--scrolltop', `${scrollTop}px`)
					window.dispatchEvent(customEvent)
				})
			}
			window.ticking = true
		} else {
			root.style.setProperty('--scrolltop', `${scrollTop}px`)
			window.dispatchEvent(customEvent)
		}
	}

	el.addEventListener('scroll', (evt) => {
		emitEvent(evt)
	}, { passive: false })
}


export class Smooth {
	constructor(el, raf) {
		this.ticking = false
		this.delta = 0
		this.scrollTop = 0
		this.dir = 1
		this.bounds = {}
		this.el = el || window
		this.root = document.querySelector(':root')
		this.raf = raf || true
	}

	static getInstance(el = window, raf = true) {
		if (!this.instance) {
			this.instance = new Smooth(el, raf)
		}

		return this.instance
	}

	init() {
		if (window == this.el) {
			this.scrollTop = window.scrollY
			this.bounds = {
				height: Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0),
				width: Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0)
			}
		} else {
			this.scrollTop = this.el?.scrollTop
			this.bounds = this.el.getBoundingClientRect()
		}
	}

	emit(evt) {
		this.scrollTop = window == this.el ? window.scrollY : this.el.scrollTop
		this.ticking = false
		this.delta = this.scrollTop - this.delta
		this.dir = this.delta < 0 ? -1 : 1

		const customEvent = new CustomEvent('smoothScroll', {
			detail: {
				bounds: this.bounds,
				scrollTop: this.scrollTop,
				delta: this.delta,
				dir: this.dir,
			}
		})
		this.delta = this.scrollTop

		if (this.raf) {
			if (!this.ticking) {
				requestAnimationFrame(() => {
					this.root.style.setProperty('--scrolltop', `${this.scrollTop}px`)
					window.dispatchEvent(customEvent)
				})
			}
			window.ticking = true
		} else {
			this.root.style.setProperty('--scrolltop', `${this.scrollTop}px`)
			window.dispatchEvent(customEvent)
		}
	}

	enable() {
		window.addEventListener('resize', this.init)
		this.el.addEventListener('scroll', () => this.emit(), { passive: false })
	}

	disable() {
		window.removeEventListener('resize', this.init)
		this.el.removeEventListener('scroll', () => this.emit())
	}

}
